var webserverRoot = window.location.protocol + "//" + window.location.hostname + pathPrefix + "Cention/web/";
var oldWebRoot = location.protocol + '//' + location.hostname;
import React from 'react';
import ReactDOM from 'react-dom';
import createReactClass from 'create-react-class';
//dev component
import Ckeditor from '../../components/Ckeditor';
import CKEditor5Component from '../../components/CKEditor5Component';
import { getCKEditorFlag } from '../../common/globals';
import FileUploader from '../../components/FileUploader';
import {I, L} from '../../common/v5/config'

var AgentAttachment = createReactClass({
	getDefaultProps: function () {
		return {
			items: {},
			deleteFromEditor: false,
			fileToBeDeleted: ""
		}
	},
	getInitialState : function(){
		return{
			items : [],
		}
	},
	componentWillMount: function () {
		this.setState({
			items: this.state.items.concat(this.props.items)
		});
	},
	componentWillReceiveProps: function(nextProps) {
		if(nextProps.deleteFromEditor && nextProps.fileToBeDeleted != "") {
			this.state.items.map(function(item, i){
				if(item.id == nextProps.fileToBeDeleted) {
					this.state.items.splice(i, 1);
				}
			},this);
		}else{
			this.setState({
				items: this.state.items.concat( nextProps.items )
			});
		}
	},
	renderSizeAccordingly: function(showSize) {
		if(showSize < 1000000)
			showSize = "("+(showSize/1000).toFixed(2)+" kb)";
		else
			showSize = "("+(showSize/1000000).toFixed(2)+" mb)";
		return showSize;
	},
	displaySizeContainer: function(origin, totalAttachmentSize) {
		if(origin=="ErrandAttachment") {
			return(
				<div className="totalSizeContainer">{I('Total Attachment Size:')} {this.renderSizeAccordingly(totalAttachmentSize)}</div>
			);
		}
	},
	render: function() {
		var showSize = "";
		var defaultOrigin = "ErrandAttachment";
		var totalAttachmentSize = 0;
		var totalSavedAttachment = 0;
		var origin = (this.props.origin ? this.props.origin : defaultOrigin);
		var maxItemLength = (this.state.items ? this.state.items.length : 0);
		return (
			<div className="attachmentItem">
				<i className="fa fa-paperclip"></i>
				{this.state.items.map(function(item, i){
					showSize = this.renderSizeAccordingly(item.estSize);
					totalAttachmentSize += item.estSize;
					var totalSavedAttachment = 0;
					if(origin=="SavedAttachement") {
						totalSavedAttachment = totalAttachmentSize;
					} else {
						if((i+1) == maxItemLength) {
							totalAttachmentSize += totalSavedAttachment;
						}
					}
					return(
						<span className="file-attach" id={"fileAttach" + item.id} key={i}>
							<a className="underlink" href={ oldWebRoot + item.download}>{item.value}</a><span className="attachmentItemSize"> {showSize}</span>
							<span className="remove-attach" id={item.id}><i onClick={this.onDeleteAttachment.bind(this,item)} id={"iconDelete_"+item.id} className="glyphicon glyphicon-remove" ></i></span>
						</span>
						)
					}.bind(this))
				}
				{this.displaySizeContainer(origin, totalAttachmentSize)}
			</div>
		);
	},
	onDeleteAttachment: function(attachment) {
		this.state.items.splice(this.state.items.indexOf(attachment), 1);
		this.forceUpdate();
		this.props.onHandle(attachment);
	}
});

var AttachmentLink = createReactClass({
	handleClick: function(e){
		this.props.onClick( this );
	},
	render: function() {
		const iconURL = process.env.CLOUDFRONT_URL+"/img/icons/";
		const attachmentIconStyle = {
			background : `url(${iconURL}icon-attachment.png) no-repeat`
		}
		return(
			<span className="icon-attachment" title={I("Attach files")} style={attachmentIconStyle} onClick={this.handleClick}></span>
		);
	}
});

var AddNewAttachmentBox = createReactClass({
	getDefaultProps: function () {
		return {
			items: {},
			visibleAttachmentBox: true
		}
	},
	render: function(){
		if(!this.props.visibleAttachmentBox)
			return(<span></span>);

		return(
			<div id="AttachFiles">
				<div className="attachFileBrowse">
					<FileUploader uploadTo="publicPage/uploadAnswerAttachment" attachFile={this.props.agentAttachFile} multipleFile={this.props.agentAttachMultipleFile} onDeleteUpload={this.handleDeleteUpload} onProgress={this.handleUploadProgress} onFileupload={this.handleFileUpload} />
				</div>
			</div>
		);
	},
	handleDeleteUpload: function( fid ){
		this.props.onUploadFinish(fid, 'del');
		if(this.props.onDeleteEditorAttachment) {
			this.props.onDeleteEditorAttachment(fid, false)
		}
	},
	handleFileUpload: function( fid ){
		this.props.onUploadFinish(fid, 'add');
		document.getElementById("LoadingAttachment").style.display = 'none';
		ReactDOM.render(
			React.createElement(AgentAttachment,{
					items: fid,
					onHandle: function( attachment ){
						this.handleDeleteUpload( attachment );
						let url = `${process.env.PUBLIC_URL}${this.props.wspace}${process.env.ORIGIN_PATH}`;
						$.post( url + "publicPage/removeTempAttachment", {fid: attachment.id});
					}.bind(this)
				}
			), document.getElementById("ErrandAttachment")
		);
	},
	handleUploadProgress: function( value ){
		document.getElementById("LoadingAttachment").style.display = 'block';
		ReactDOM.render(<div><img src="/img/loading-attachment.gif" /></div>, document.getElementById("LoadingAttachment"));
	}
});

var SaveAnswer = createReactClass({
	getInitialState: function(){
		this.answerList = [];
		this.identifier = "";
		this.uploadedAttachments = [];
		this.message = "";
		this.editorAttachment = [];

		return {
			mount: false,
			AfterSentMessage: ""
		};
	},
	getUrlParams: function(arr, str) {
		for(var i=0; i<arr.length; i++) {
			if (arr[i] == str) {
				return arr[i+1];
			}
		}
		return 0;
	},
	componentWillMount: function() {
		var req = window.location.hash.split('#')[1];
		if(typeof req != 'undefined' && req != "") {
			var params = req.split('/');
			if (params.length > 0) {
				this.identifier = this.getUrlParams(params, "answer");
			}
		}
	},
	_Cke: function( textareaName ) {
		return CKEDITOR.instances[textareaName + "Wysiwyg"];
	},
	clearAnswer: function() {
		if(this._Cke("Question") )
			this._Cke("Question").updateElement();
		this._Cke("Question").setData("");
	},
	handleDragnDropFiles: function(event) {
		if( event.data ){
			var i = 1;
			var fd = new FormData();
			var boundary = Math.floor(Math.random() * 6)+ ''+ i +''+ Math.floor(''+new Date() / 1000) ;
			var fileNameOnly = event.data.name;
			var attachments = [];
			fd.append( 'uploadfile', event.data );
			fd.append( 'fileNameOnly', fileNameOnly);
			fd.append( 'random', parseFloat(boundary));
			fd.append( 'fileType', event.data.type);
			if(event.data.name != undefined){
				fd.append( 'eventType', 'drag');
			}else{
				fd.append( 'eventType', 'paste');
			}
			let url = `${process.env.PUBLIC_URL}${this.props.wspace}${process.env.ORIGIN_PATH}`;
			$.ajax({
				url: url + "publicPage/uploadAnswerAttachment",
				data: fd,
				processData: false,
				contentType: false,
				type: 'POST',
				success: function( uploadFile ){
					// TODO CS-525 ensure attachment id is encrypted (probably already is)
					if(event.data.name != undefined){
						this.setImageSrcToCk(uploadFile, event);
					}else{
						if(event.data.type) {
							var fileType = event.data.type;
							var fileExtension = fileType.split('/').pop();
							uploadFile.value = uploadFile.value+"."+fileExtension;
						}
						this.setImageSrcToCk(uploadFile, event);
					}
					attachments.push(uploadFile);
					this.editorAttachment.push(attachments[0]);
					this.appendEditorAttachments(attachments, false, "");
				}.bind(this)
			});
		}
	},
	appendEditorAttachments: function(attachments, del, toDel){
		if (Array.isArray(attachments) == false) {
			return;
		}
		var items = [];
		for (var i = 0; i < attachments.length; i++) {
			if(!del) {
				this.uploadedAttachments.push(attachments[i].id);
			}
			items.push({
				id: attachments[i].id,
				name: attachments[i].value,
				value: attachments[i].value,
				estSize: attachments[i].estSize,
				download: attachments[i].download,
				src: attachments[i].download
			});
		}
		ReactDOM.render(
			React.createElement(AgentAttachment, {
				items: items,
				deleteFromEditor: del,
				fileToBeDeleted: toDel,
				onHandle: function(attachment) {
					if (this.uploadedAttachments.indexOf(attachment.id) !== -1) {
						this.uploadedAttachments.splice(this.uploadedAttachments.indexOf(attachment.id), 1);
					}
					this.handleDeleteEditorAttachment( attachment , false );
					let url = `${process.env.PUBLIC_URL}${this.props.wspace}${process.env.ORIGIN_PATH}`;
					$.post( url + "publicPage/removeTempAttachment", {fid: attachment.id});
				}.bind(this)
			}),
			document.getElementById('ErrandAttachment')
		);
	},
	handleDeleteEditorAttachment: function(fid,deleteFromEditor){
		this.handleFileUploadFinish(fid, "del");
		if(!deleteFromEditor) {
			this.handleRemoveFromEditor(fid.id);
		}
	},
	handleRemoveFromEditor: function(imgId) {
		var removeImgElements = function(answerText, selector) {
			var wrapped = $("<div>" + answerText + "</div>");
			wrapped.find(selector).remove();
			return wrapped.html();
		}
		var removedImg = removeImgElements(this.message, "img#"+imgId);
		CKEDITOR.instances['QuestionWysiwyg'].setData(removedImg);
	},
	setImageSrcToCk: function( img, editor ){
		var fileType = editor.data.type;
		var fileExtension = "."+fileType.split('/').pop();
		if(fileExtension.match(/\.(jpg|jpeg|png|gif)$/)){
			if(this._Cke("Question") )
				this._Cke("Question").updateElement();
			var context = '<img src="'+ img.download +'" alt="" class="editorImage" id="'+img.id+'" />';
			this._Cke("Question").insertHtml(context);
		}
	},
	handleKeyDown: function(event) {
		this.message = event.editor.getData();
	},
	handleCkeditorChange: function(event) {
		this.message = event.editor.getData();
	},
	handleCustomEvent: function(event) {
		this.message = event.target.value;
	},
	handleUndoImage: function(editor, event, selectedElement) {
		var imgId = selectedElement.$.id;
		for(var i=0;i<this.editorAttachment.length;i++) {
			var editorImgID = this.editorAttachment[i].id;
			if(imgId == editorImgID) {
				this.handleDeleteEditorAttachment(this.editorAttachment[i], true)
				this.editorAttachment.splice(i, 1);
				this.appendEditorAttachments(this.editorAttachment, true, editorImgID);
			}
			setTimeout(function(){
				this.message = event.editor.getData();
				this.refs.QuestionWysiwyg.setData(this.message);
			}.bind(this), 10);
		}
	},
	renderCkeditor: function(id) {
		if(getCKEditorFlag()){
			return (
				<CKEditor5Component
					id="QuestionWysiwyg"
					ref="QuestionWysiwyg"
					defaultFontFamily="Arial"
					defaultFontSize="10"
					defaultContent=""
					spellLanguages={this.answerList.ckLanguages}
					showResize={false}
					onKeydown={this.handleKeyDown}
					fileArchiveImages={[]}
					simpleToolbar={false}
					onChange={this.handleCkeditorChange}
					defShowSpellchk={false}
					height="200"
					onUndoImage={this.handleUndoImage}
					useServerUpload={false}
				/>
			)
		} else if(CKEDITOR.env.isCompatible){
			return (
				<Ckeditor
					id="QuestionWysiwyg"
					ref="QuestionWysiwyg"
					defaultFontFamily="Arial"
					defaultFontSize="10"
					defaultContent=""
					spellLanguages={this.answerList.ckLanguages}
					showResize={false}
					onKeydown={this.handleKeyDown}
					fileArchiveImages={[]}
					simpleToolbar={false}
					onChange={this.handleCkeditorChange}
					defShowSpellchk={false}
					height="200"
					onDragnDropFiles={this.handleDragnDropFiles}
					onUndoImage={this.handleUndoImage}
				/>
			)
		}else{
			//alert('ckeditor not supported');
			return (
				<textarea
					className="form-control"
					id={this.props.id}
					name={this.props.id}
					ref={this.props.id}
					onChange={this.handleCustomEvent}
				/>
			)
		}
	},
	handleFileUploadFinish: function( attachment, todo ){
		var attachmentId = attachment.id;
		if(todo === 'add')
			this.uploadedAttachments.push(attachmentId);
		if(todo === 'del'){
			if(this.uploadedAttachments.indexOf(attachmentId) !== -1)
				this.uploadedAttachments.splice(this.uploadedAttachments.indexOf(attachmentId), 1);
		}
		this.renderAttachmentPanel();
	},
	renderAttachmentPanel: function() {
		this.visibleAttachmentBox = !this.visibleAttachmentBox;
		return(
			ReactDOM.render(
				<AddNewAttachmentBox
					id="fileAttachment"
					wspace={this.props.wspace}
					visibleAttachmentBox={this.visibleAttachmentBox}
					agentAttachFile={true }
					agentAttachMultipleFile={true}
					onUploadFinish={this.handleFileUploadFinish}
					onDeleteEditorAttachment={this.handleDeleteEditorAttachment}
				/>, document.getElementById("AttachmentPanel")
			)
		);
	},
	handleSaveAnswer: function() {
		var params = {
			identifier: 					this.identifier,
			message:    					this.message,
			attachments: 					this.uploadedAttachments
		}
		let url = `${process.env.PUBLIC_URL}${this.props.wspace}${process.env.ORIGIN_PATH}`;
		$.post(url + "externalexpert/answer/save", {params: JSON.stringify(params, null, '  ')}).done(function(data) {
			if(data.list && data.list.success) {
				this.setState({afterSentMessage: data.list.success});
			} else {
				this.setState({afterSentMessage: data.list.error});
			}
		}.bind(this));
	},
	renderPanelBody: function() {
		var BoxTextArea = {									
			backgroundColor: '#FFFFFF',
			border: '1px solid #ddd',
			height: '200px',
			overflow: 'auto',
			width: '100%',
			resize: 'none',
			marginBottom:'10px',
			fontFamily:'Verdana',
			fontSize:'12px',
			padding:'10px'
		};
		return (
			<div className="panel-body">
				<div className="row">
					<div className="col-md-12">
						<div className="form-group1">
							<div className="row">
								<div className="col-md-2 bold">
									{I('From')}
								</div>
								<div className="col-md-4">
									{this.answerList.from}
								</div>
								<div className="col-md-2 bold">
									{I('Date')}
								</div>
								<div className="col-md-4">
									{this.answerList.date}
								</div>
							</div>
						</div>
						<div className="form-group1">
							<div className="row">
								<div className="col-md-2 bold">
									{I('To')}
								</div>
								<div className="col-md-4">
									{this.answerList.to}
								</div>
								<div className="col-md-2 bold">
									{I('Copy to')}
								</div>
								<div className="col-md-4">
									{this.answerList.cc}
								</div>
							</div>
						</div>
						<div className="form-group1">
							<div className="row">
								<div className="col-md-2 bold">
									{I('Subject')}
								</div>
								<div className="col-md-10">
									{this.answerList.subject}
								</div>
							</div>
						</div>
						<div className="form-group1">
							<div className="row">
									<div className="col-md-2 bold">{I('Attachments in thread, incoming')}</div>
									<div className="col-md-4" dangerouslySetInnerHTML={{__html: this.answerList.incomingAttachments}}></div>
									<div className="col-md-2 bold">{I('Outgoing')}</div>
									<div className="col-md-4" dangerouslySetInnerHTML={{__html: this.answerList.outgoingAttachments}}></div>
							</div>
						</div>
						<div className="form-group1">
							<div className="row">
								<div className="col-md-2 bold">{I('Attachments from agent')}</div>
								<div className="col-md-4" dangerouslySetInnerHTML={{__html: this.answerList.attachmentsFromAgent}}></div>
							</div>
						</div>
						<div className="clear" style={{padding: '20px'}}></div>
						<div className="form-group1">
							<div className="row">
								<div className="col-md-12 bold">{I('Message from agent')}</div>
								<div className="col-md-12">
									<div id={"Message"} style={BoxTextArea} dangerouslySetInnerHTML={{__html: this.answerList.agentMessage}}></div>	
								</div>
							</div>
						</div>
						{this.answerList.historyMessage != "" ? 
							<div className="form-group1">
								<div className="row">
									<div className="col-md-12 bold">{I('Original errand and history')}</div>
									<div className="col-md-12">
										<div id={"HistoryMessage"} style={BoxTextArea} dangerouslySetInnerHTML={{__html: this.answerList.historyMessage}}></div>	
									</div>
								</div>
							</div> : ""
						}
						{this.answerList.collabMessage != "" ?
							<div className="form-group1">
								<div className="row">
									<div className="col-md-12 bold">{I('Collaboration history')}</div>
									<div className="col-md-12">
										<div id={"CollabHistoryMessage"} style={BoxTextArea} dangerouslySetInnerHTML={{__html: this.answerList.collabMessage}}></div>
									</div>
								</div>
							</div> : ""
						}	
						<div className="form-group1">
							<div className="row">
								<div className="col-md-12 bold">{I('Message to agent')}</div>
								<div className="col-md-12">
									<div id="queryInput" style={{border:'1px solid #cecece'}}>
										{this.state.mount ? this.renderCkeditor() : ""}	
									</div>
								</div>
							</div>
						</div>														
					</div>
					<div className="clear" style={{paddingTop: '20px'}}></div>
					<div className="col-md-12">
						<div id="AttachmentPanel"></div>
						<div className="errand-attachment" id="ErrandAttachment" ></div>
						<span id="LoadingAttachment" style={{display:'none'}}></span>
					</div>
					<div className="clear" style={{paddingTop: '20px'}}></div>
					<div className="row" style={{background: '#F5F5F5'}}>
						<div className="col-md-6 query-answer-option">
							<AttachmentLink onClick={this.renderAttachmentPanel} />
						</div>			
					</div>
					<div className="row" style={{background: '#F5F5F5',paddingTop: '20px'}}>
						<div className="col-md-6">
								<button className="btn btn-outline btn-success btn-sm" type="button"  onClick={this.handleSaveAnswer}>{I('Send Answer')}</button>
						</div>
					</div>
				</div>
			</div>
		);
	},
	render: function() {
		return (
			<div id="content">
				<div className="wrapper">
					<div id="page-wrapper" className="externalexpert-page">
						<div className="row">
							<div className="col-lg-12">
								<div style={{marginBottom:'30px', fontSize:'14px', color:'#000000', marginTop: '15px'}}>
									<span className="headline"><strong>Errands</strong> | External expert queries</span>
								</div>
							</div>
							{this.state.afterSentMessage ? 
								<div className="col-lg-12">
									{this.state.afterSentMessage}
								</div>
								: this.renderPanelBody()
							}
						</div>
					</div>
				</div>
			</div>
		);
	},
	componentDidMount: function() {
		var params = {
			identifier: this.identifier
		}
		let url = `${process.env.PUBLIC_URL}${this.props.wspace}${process.env.ORIGIN_PATH}`;
		$.post(url + "externalexpert/answer", {params: JSON.stringify(params, null, '  ')}).done(function(data) {
				if(data.list) {
					this.answerList = data.list;		 
				}
				this.setState({mount: true});
		}.bind(this));
	}
});
export default SaveAnswer;
